import { GeneralPhotoRemarksDto } from "./generalPhotoRemarksDto";

export class ChangeInsideSurveyPhotoRemarksDto {
  surveyId: string;
  facadePhotoRemark: string;
  outsideIntroPhotoRemark: string;
  undergroundPhotoRemark: string;
  generalPhotoRemarks: GeneralPhotoRemarksDto[];
  floorPlanPhotoRemark: string;

  constructor(
    surveyId: string,
    facadePhotoRemark: string,
    outsideIntroPhotoRemark: string,
    undergroundPhotoRemark: string,
    generalPhotoRemarks: GeneralPhotoRemarksDto[],
    floorPlanPhotoRemark: string
  ) {
    this.surveyId = surveyId;
    this.facadePhotoRemark = facadePhotoRemark;
    this.outsideIntroPhotoRemark = outsideIntroPhotoRemark;
    this.undergroundPhotoRemark = undergroundPhotoRemark;
    this.generalPhotoRemarks = generalPhotoRemarks;
    this.floorPlanPhotoRemark = floorPlanPhotoRemark;
  }
}
